module.exports = __webpack_public_path__ + "static/media/along.31d4cf5c.JPG";